export const DATE_FORMAT = "DD.MM.YYYY";
export const DATE_TIME_FORMAT = `${DATE_FORMAT} HH:mm:ss`;
